import axios from './client'
import { FoldersResponse, FolderDetailResponse, FolderResponse } from '../types/folder'
import type { ReleaseFilters } from '../types/release'

export async function getFolders(): Promise<FoldersResponse> {
  const { data } = await axios.get('/folders')
  return data
}

export async function createFolder(name: string, color?: string): Promise<FolderResponse> {
  const { data } = await axios.post('/folders', { name, color })
  return data
}

export async function updateFolder(
  id: number,
  updates: { name?: string; color?: string }
): Promise<FolderResponse> {
  const { data } = await axios.put(`/folders/${id}`, updates)
  return data
}

export async function deleteFolder(id: number): Promise<{ success: boolean }> {
  const { data } = await axios.delete(`/folders/${id}`)
  return data
}

export async function getFolderReleases(
  id: number,
  filters: ReleaseFilters = {}
): Promise<FolderDetailResponse> {
  const { data } = await axios.get(`/folders/${id}/releases`, {
    params: {
      page: filters.page ?? 1,
      per_page: filters.per_page ?? 50,
      sort: filters.sort ?? 'date',
      order: filters.order ?? 'desc',
      q: filters.q,
      genres: filters.genres,
      styles: filters.styles,
      genre_mode: filters.genre_mode,
      style_mode: filters.style_mode,
      year_from: filters.year_from,
      year_to: filters.year_to,
      min_want: filters.min_want,
      min_median: filters.min_median,
      max_median: filters.max_median,
    }
  })
  return data
}

export async function addReleaseToFolder(
  folderId: number,
  releaseId: number
): Promise<{ success: boolean }> {
  const { data } = await axios.post(`/folders/${folderId}/releases/${releaseId}`)
  return data
}

export async function removeReleaseFromFolder(
  folderId: number,
  releaseId: number
): Promise<{ success: boolean }> {
  const { data } = await axios.delete(`/folders/${folderId}/releases/${releaseId}`)
  return data
}

export async function getReleaseFolders(releaseId: number): Promise<FoldersResponse> {
  const { data } = await axios.get(`/folders/releases/${releaseId}/folders`)
  return data
}

export async function getFolderReleaseIds(id: number): Promise<{ success: boolean; release_ids: number[] }> {
  const { data } = await axios.get(`/folders/${id}/release-ids`)
  return data
}

export async function getFolderMasterFilter(
  folderId: number,
  releaseIds: number[]
): Promise<{ success: boolean; release_ids: number[] }> {
  const { data } = await axios.post(`/folders/${folderId}/master-filter`, { release_ids: releaseIds })
  return data
}
